import emailLogsService from '@/api/email-logs-service';

const state = {
  emailLogs: null,
  selectedEmailLog: {},
  emailLogsPagination: {},
  emailLogsFilterParams: {},
};

const mutations = {
  SET_EMAIL_LOGS(state, { data, current_page, per_page, total }) {
    state.emailLogs = data;
    state.emailLogsPagination = {
      current_page,
      per_page,
      total,
    };
  },

  SET_SELECTED_EMAIL_LOG(state, log) {
    state.selectedEmailLog = JSON.parse(JSON.stringify(log));
  },

  SET_FILTER_PARAMS(state, params) {
    state.emailLogsFilterParams = params;
  },
};

const actions = {
  fetchEmailLogs({ commit }, params = {}) {
    commit('SET_FILTER_PARAMS', params);
    return emailLogsService.getPage(params).then((res) => {
      commit('SET_EMAIL_LOGS', res.data);
    });
  },

  selectEmailLog({ state, commit }, logId) {
    const log = state.emailLogs?.find((l) => l.id === logId);
    if (log) {
      commit('SET_SELECTED_EMAIL_LOG', log);
      return Promise.resolve(log);
    }
    return emailLogsService.getById(logId).then((res) => {
      commit('SET_SELECTED_EMAIL_LOG', res.data);
      return res.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
